module.exports = __webpack_public_path__ + "img/check-icon.7d41a120.svg";